import { render, staticRenderFns } from "./DeleteVirtualAliasModal.vue?vue&type=template&id=71680759&"
import script from "./DeleteVirtualAliasModal.vue?vue&type=script&lang=js&"
export * from "./DeleteVirtualAliasModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports